export default "__VITE_ASSET__BGP5kCJw__"